import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { c as EGDSPagingButton } from '../paging-button/index-chunk.esm.js';

class EGDSPagingNextButton extends React.Component {
    static displayName = 'EGDSPagingNextButton';
    render() {
        return jsx(EGDSPagingButton, { ...this.props, icon: "chevron_right" });
    }
}

class EGDSPagingPrevButton extends React.Component {
    static displayName = 'EGDSPagingPrevButton';
    render() {
        return jsx(EGDSPagingButton, { ...this.props, icon: "chevron_left" });
    }
}

export { EGDSPagingNextButton as E, EGDSPagingPrevButton as a };
//# sourceMappingURL=index-chunk.esm.js.map
